import {DrawViewController} from './draw-view.controller';
import template from './draw-view.template.html';

export const DrawViewComponent = {
    controller: DrawViewController,
    templateUrl: template
};



// WEBPACK FOOTER //
// ./src/js/views/draw-view/draw-view.component.js